import { useMutation } from '@tanstack/react-query';

import { BoxConfig } from '../../models/boxConfig';
import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';
import { MutationConfig } from '@/lib/react-query';

const updateBoxConfiguration =
  (makeRequest: any, boxId: string) =>
  async ({ newData }: { newData: BoxConfig }): Promise<BoxConfig> => {
    const { data, error } = await makeRequest({
      path: `/boxes/${boxId}/configuration`,
      method: 'put',
      body: newData,
    });

    if (!data || error) {
      throw new Error(error.response?.data?.message);
    }

    return data;
  };

type UseUpdateBoxConfiguration = {
  config?: MutationConfig<ReturnType<typeof updateBoxConfiguration>>;
  boxId: string;
};

export const useUpdateBoxConfiguration = ({
  config,
  boxId,
}: UseUpdateBoxConfiguration) => {
  const [, makeRequest] = useImperativeRequestWrapper('device');

  return useMutation({
    ...config,
    mutationFn: updateBoxConfiguration(makeRequest, boxId),
  });
};
